/* eslint-disable radix */
/* eslint-disable camelcase */
import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';
import Agent from '../../api/Agent';
import { handleError } from '../user';
import history from '../../config/history';
import mixpanelConstants from '../../constants/mixpanel';

export const setOrganization = createAction('SET_ORGANIZATION');
export const setPageNumber = createAction('SET_ORGANIZATION_PAGE_NUMBER');
export const setSearchString = createAction('SET_SEARCH_STRING');
export const setSort = createAction('SET_SORT');
export const setSortOrder = createAction('SET_SORT_ORDER');
export const setLoaderDisplay = createAction('SET_LOADER_DISPLAY');
export const setImgMsgDisplay = createAction('SET_IMG_MSG_DISPLAY');
export const setName = createAction('SET_NAME');
export const setType = createAction('SET_TYPE');
export const setCity = createAction('SET_CITY');
export const setState = createAction('SET_STATE');
export const setLogo = createAction('SET_LOGO');
export const setCutoff = createAction('SET_CUTOFF');
export const setOrgId = createAction('SET_ORGID');
export const setTypeId = createAction('SET_TYPE_ID');
export const setblueloadDisplay = createAction('SET_BLUE_LOAD_DISPLAY');
export const setRedirectOrg = createAction('SET_REDIRECT_ORG');
export const setOrgStatusId = createAction('SET_ORG_STATUS_ID');
export const setOrgStatusTypes = createAction('SET_ORG_STATUS_TYPES');
export const setTimezone = createAction('SET_TIMEZONE_ID');
export const setTimezones = createAction('SET_TIMEZONES');
export const setOrgStatusFilter = createAction('SET_ORG_STATUS_FILTER');

export const clearOrgName = createAction('CLEAR_ORG_NAME');
export const clearOrgType = createAction('CLEAR_ORG_TYPE');
export const clearTimezone = createAction('CLEAR_TIMEZONE');
export const clearOrgCity = createAction('CLEAR_ORG_CITY');
export const clearOrgState = createAction('CLEAR_ORG_STATE');
export const clearOrgLogo = createAction('CLEAR_ORG_LOGO');
export const clearOrgCutOff = createAction('CLEAR_ORG_CUTOFF');
export const clearOrgId = createAction('CLEAR_ORG_ID');
export const resetOrgDashboard = createAction('RESET_ORG_DASHBOARD_LIST');

export const setEMRList = createAction('SET_EMR_LIST');
export const setOrgEMR = createAction('SET_ORG_EMR');
export const clearOrgEMR = createAction('CLEAR_ORG_EMR');

const initialState = {
	emrList: [],
	img_msg: 'none',
	loaddisplay: 'none',
	loader_display: 'none',
	org_city: '',
	org_cutoff: '0',
	org_emr: [],
	org_logo: '',
	org_name: '',
	org_state: '',
	org_type: [],
	organization_id: 0,
	organizationList: {},
	orgStatusFilter: 0,
	page_no: 1,
	search_string: '',
	sort: 'id',
	sortorder: 'asc',
	timezone_id: '1',
	timezones: [],
	type_id: '0',
	userRedirectOrg: '0'
};

export default handleActions(
	{
		CLEAR_ORG_CITY: (state) => ({ ...state, org_city: initialState.org_city }),
		CLEAR_ORG_CUTOFF: (state) => ({ ...state, org_cutoff: initialState.org_cutoff }),
		CLEAR_ORG_EMR: (state) => ({ ...state, org_emr: initialState.org_emr }),
		CLEAR_ORG_ID: (state) => ({ ...state, organization_id: initialState.organization_id }),
		CLEAR_ORG_LOGO: (state) => ({ ...state, org_logo: initialState.org_logo }),
		CLEAR_ORG_NAME: (state) => ({ ...state, org_name: initialState.org_name }),
		CLEAR_ORG_STATE: (state) => ({ ...state, org_state: initialState.org_state }),
		CLEAR_ORG_TYPE: (state) => ({ ...state, type_id: initialState.type_id }),
		CLEAR_TIMEZONE: (state) => ({ ...state, timezone_id: initialState.timezone_id }),
		RESET_ORG_DASHBOARD_LIST: () => initialState,
		SET_BLUE_LOAD_DISPLAY: (state, action) => ({ ...state, loaddisplay: action.payload }),
		SET_CITY: (state, action) => ({ ...state, org_city: action.payload }),
		SET_CUTOFF: (state, action) => ({ ...state, org_cutoff: action.payload }),
		SET_EMR_LIST: (state, action) => ({ ...state, emrList: mapEMRToOptions(action.payload) }),
		SET_IMG_MSG_DISPLAY: (state, action) => ({ ...state, img_msg: action.payload }),
		SET_LOADER_DISPLAY: (state, action) => ({ ...state, loader_display: action.payload }),
		SET_LOGO: (state, action) => ({ ...state, org_logo: action.payload }),
		SET_NAME: (state, action) => ({ ...state, org_name: action.payload }),
		SET_ORG_EMR: (state, action) => ({ ...state, org_emr: action.payload }),
		SET_ORG_STATUS_FILTER: (state, action) => ({ ...state, orgStatusFilter: action.payload }),
		SET_ORG_STATUS_ID: (state, action) => ({ ...state, orgStatusId: action.payload }),
		SET_ORG_STATUS_TYPES: (state, action) => ({ ...state, orgStatusTypes: action.payload }),
		SET_ORGANIZATION: (state, action) => ({ ...state, organizationList: action.payload }),
		SET_ORGANIZATION_PAGE_NUMBER: (state, action) => ({ ...state, page_no: action.payload }),
		SET_ORGID: (state, action) => ({ ...state, organization_id: action.payload }),
		SET_REDIRECT_ORG: (state, action) => ({ ...state, userRedirectOrg: action.payload }),
		SET_SEARCH_STRING: (state, action) => ({ ...state, search_string: action.payload }),
		SET_SORT: (state, action) => ({ ...state, sort: action.payload }),
		SET_SORT_ORDER: (state, action) => ({ ...state, sortorder: action.payload }),
		SET_STATE: (state, action) => ({ ...state, org_state: action.payload }),
		SET_TIMEZONE_ID: (state, action) => ({ ...state, timezone_id: action.payload }),
		SET_TIMEZONES: (state, action) => ({ ...state, timezones: action.payload }),
		SET_TYPE: (state, action) => ({ ...state, org_type: action.payload }),
		SET_TYPE_ID: (state, action) => ({ ...state, type_id: action.payload })
	},
	initialState
);

function mapEMRToOptions(emrs) {
	return emrs.map((emr) => ({
		label: emr.name,
		value: emr.id
	}));
}

// function mapOptionsToEMR(emrs) {
// 	return emrs.map((emr) => ({
// 		enabled: emr.enabled,
// 		id: emr.value,
// 		name: emr.label
// 	}));
// }

export const clearFormValue = () =>
	function (dispatch) {
		dispatch(clearOrgName());
		dispatch(clearOrgType());
		dispatch(clearOrgCity());
		dispatch(clearOrgState());
		dispatch(clearTimezone());
		dispatch(clearOrgLogo());
		dispatch(clearOrgCutOff());
		dispatch(clearOrgId());
		dispatch(clearOrgEMR());
	};

export const pageNumber = (pageNo) =>
	function (dispatch) {
		// const {search_string,sort,sortorder} = getState().adminOrganization
		dispatch(setPageNumber(pageNo));
		dispatch(getAdminOrg());
	};

export const getAdminOrg = () =>
	function (dispatch, getState) {
		const { page_no, search_string, sort, sortorder, orgStatusFilter } = getState().adminOrganization;
		dispatch(setblueloadDisplay('block'));

		Agent.getAdminOrganizations(page_no, search_string, sort, sortorder, orgStatusFilter).then((response) => {
			if (response.ok) {
				dispatch(setOrganization(response.data));
			} else {
				dispatch(handleError(response));
			}
			dispatch(setblueloadDisplay('none'));
		});
	};

export const createOrganization = () =>
	function (dispatch, getState) {
		const {
			organization_id,
			org_name,
			timezone_id,
			org_city,
			org_state,
			org_logo,
			org_cutoff,
			org_type,
			org_emr,
			orgStatusId
		} = getState().adminOrganization;

		const emrValues = (org_emr || []).map((emr) => ({
			id: emr
		}));

		// organization_id, title,address,city,state,zip,phone_number,storage_location,organization_type,shift_cutoff_hours
		Agent.createOrganization(
			organization_id,
			false,
			org_name,
			org_city,
			org_state,
			org_logo,
			parseInt(timezone_id),
			parseInt(org_cutoff),
			emrValues,
			parseInt(orgStatusId)
		).then((response) => {
			if (response.ok) {
				mixpanel.track(mixpanelConstants.ADD_NEW_ORGANIZATION, {
					city: org_city,
					cutOff: org_cutoff,
					emr: getEMRString(emrValues),
					name: org_name,
					state: org_state,
					type: org_type.name
				});

				history.push(`/admin/organization/detail/${response.data.organization_id}`);
			}
		});
	};

export const uploadLogo = (file) =>
	function (dispatch) {
		if (file) {
			dispatch(setLoaderDisplay('block'));
			Agent.commonFileUpload(file).then((response) => {
				if (response.ok) {
					dispatch(setLogo(response.data.path));
					dispatch(setImgMsgDisplay('block'));
					dispatch(setLoaderDisplay('none'));
				} else {
					dispatch(setLoaderDisplay('none'));
					alert('Failed to upload file. Please check you file type and file size.');
				}
			});
		} else {
			dispatch(setLoaderDisplay('none'));
		}
	};

export const getCSType = () =>
	function (dispatch) {
		Agent.CSType().then((response) => {
			if (response.ok) {
				dispatch(setType(response.data));
			} else {
				dispatch(handleError(response));
			}
		});
	};

export const getTimezones = () =>
	function (dispatch) {
		Agent.getTimezones().then((response) => {
			if (response.ok) {
				dispatch(setTimezones(response.data));
			}
		});
	};

export const getOrgStatusTypes = () =>
	function (dispatch) {
		Agent.getOrgStatusTypes().then((response) => {
			if (response.ok) {
				dispatch(setOrgStatusTypes(response.data));
			}
		});
	};
export const getEMRList = () => (dispatch) => {
	Agent.getEMRList().then((response) => {
		if (response.ok) {
			dispatch(setEMRList(response.data));
		} else {
			dispatch(handleError(response));
		}
	});
};

export const getEMRString = (emr) => {
	if (!emr) return '';
	const emrList = emr.filter((e) => e.enabled).map((e) => e.name) || [];

	return emrList.join(', ');
};
